import gql from "graphql-tag";
import { graphql, QueryResult } from "react-apollo";

import { orderByOrderNumberAndPostalCode } from "~/graphql/types";

export interface IResponseProps {
  orderQuery: orderByOrderNumberAndPostalCode & QueryResult;
}

export interface IInputProps {
  orderNumber: string;
  postalCode: string;
}

export const PRODUCT_TITLE_TRANSLATION_FRAGMENT = gql`
  fragment ProductTitleTranslationFragment on ProductTitleTranslation {
    id
    language
    value
  }
`;

export const PRODUCT_TITLE_FRAGMENT = gql`
  fragment ProductTitleFragment on ProductTitle {
    id

    translations(filter: { language: $languageCode }) {
      ...ProductTitleTranslationFragment
    }
  }

  ${PRODUCT_TITLE_TRANSLATION_FRAGMENT}
`;

export const PRODUCT_FRAGMENT = gql`
  fragment ProductFragment on Product {
    id
    sourceName

    titles(filter: { type: PRIMARY_TITLE }) {
      ...ProductTitleFragment
    }
  }

  ${PRODUCT_TITLE_FRAGMENT}
`;

export const SUPPLIER_ORDER_FRAGMENT = gql`
  fragment SupplierOrderFragment on SupplierOrder {
    id
    status
    trackingCode
  }
`;

export const ORDER_ITEM_FRAGMENT = gql`
  fragment OrderItemFragment on OrderItem {
    id
    quantity
    status
    trackingNumber
    supplier
    ean

    createdAt

    product {
      ...ProductFragment
    }

    supplierOrder {
      ...SupplierOrderFragment
    }
  }
  ${PRODUCT_FRAGMENT}
  ${SUPPLIER_ORDER_FRAGMENT}
`;

export const ORDER_QUERY = gql`
  query orderByOrderNumberAndPostalCode(
    $orderNumber: String!
    $postalCode: String!
    $languageCode: String = "en"
  ) {
    order: orderByNumberAndPostalCode(
      orderNumber: $orderNumber
      postalCode: $postalCode
    ) {
      id
      number
      customerFullname

      shipmentPrice
      createdAt

      orderItems {
        ...OrderItemFragment
      }
    }
  }

  ${ORDER_ITEM_FRAGMENT}
`;

export const withOrderByNumberAndPostalCode = graphql<IInputProps>(
  ORDER_QUERY,
  {
    name: "orderQuery",
    options({ orderNumber, postalCode }) {
      return {
        variables: {
          orderNumber,
          postalCode
        }
      };
    }
  }
);

export {
  orderByOrderNumberAndPostalCode,
  orderByOrderNumberAndPostalCode_order as IOrder,
  orderByOrderNumberAndPostalCode_order_orderItems as IOrderItem,
  orderByOrderNumberAndPostalCodeVariables
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/queries/order/orderByNumberAndPostalCode.ts